import type { CityConfig } from "../city-template/types";

export const vailConfig: CityConfig = {
  city: "Vail",
  state: "Colorado",
  stateAbbr: "CO",
  slug: "vail",
  route: "/cities/vail",
  title: "Emergency Passport Vail, CO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Vail, Colorado — as fast as 24 hours. Same-day courier processing for Vail, Avon, Beaver Creek, Edwards, and all Eagle County travelers. A+ BBB rated, registered State Dept. courier. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Vail, CO",
  heroSubtitle: "Ski trip to the Swiss Alps in 5 days and your passport just expired? International business conference in London and you need documents fast? We help Vail residents — from Lionshead to East Vail to the Vail Valley communities — get their passports as fast as 24 hours. A+ BBB rated registered courier serving all of Eagle County.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Vail%20Colorado%20scenic%20winter%20landscape%20with%20the%20iconic%20Vail%20Mountain%20ski%20slopes%20under%20bright%20blue%20sky%2C%20the%20charming%20Vail%20Village%20with%20Bavarian%20style%20architecture%20and%20pedestrian%20cobblestone%20streets%20covered%20in%20fresh%20snow%2C%20Gore%20Creek%20running%20through%20the%20village%20center%2C%20luxury%20ski%20resort%20atmosphere%20with%20mountain%20peaks%20in%20the%20background%2C%20crisp%20winter%20light%20with%20long%20shadows%2C%20professional%20landscape%20photography%2C%20no%20visible%20text%20or%20people%2C%20cinematic%20wide%20angle%20view&width=1800&height=700&seq=vail-hero-001&orientation=landscape",
  heroImageAlt: "Vail Colorado with ski slopes, Bavarian-style Vail Village, and Gore Creek",
  geoPosition: "39.6433;-106.3781",
  geoPlacename: "Vail, Colorado",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Colorado Passport Agency",
    address: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
    distance: "Approximately 100 miles east via I-70 — about 2 hours",
  },
  nearbyCitiesZips: [
    { name: "Vail", zips: "81657, 81658" },
    { name: "Lionshead", zips: "81657" },
    { name: "East Vail", zips: "81657" },
    { name: "West Vail", zips: "81657" },
    { name: "Avon", zips: "81620" },
    { name: "Beaver Creek", zips: "81620" },
    { name: "Edwards", zips: "81632" },
    { name: "Eagle", zips: "81631" },
    { name: "Minturn", zips: "81645" },
    { name: "Gypsum", zips: "81637" },
    { name: "Red Cliff", zips: "81649" },
    { name: "Wolcott", zips: "81655" },
    { name: "Eagle-Vail", zips: "81620" },
    { name: "Cordillera", zips: "81632" },
    { name: "Bachelor Gulch", zips: "81620" },
    { name: "Arrowhead", zips: "81632" },
    { name: "Frisco", zips: "80443" },
    { name: "Silverthorne", zips: "80498" },
    { name: "Dillon", zips: "80435" },
    { name: "Breckenridge", zips: "80424" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier for urgent Vail departures — EGE is just 35 minutes west" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved — skip the 2-hour I-70 drive to Denver" },
    { icon: "ri-flight-takeoff-line", title: "EGE Airport Gateway", desc: "Eagle County Regional Airport with seasonal international flights at your doorstep" },
    { icon: "ri-mail-send-line", title: "Overnight Shipping", desc: "Prepaid labels from any UPS or FedEx in the Vail Valley" },
  ],
  internalLinks: [
    { name: "Expedited passport in Denver, CO", route: "/cities/denver" },
    { name: "Emergency passport help in Aspen, CO", route: "/cities/aspen" },
    { name: "Fast passport renewal in Breckenridge area", route: "/cities/vail" },
    { name: "Urgent passport services for Beaver Creek and Avon", route: "/cities/vail" },
    { name: "Colorado passport services overview", route: "/states/colorado" },
    { name: "Passport courier services in Edwards and Eagle", route: "/cities/vail" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Vail remotely via secure registered courier. Our couriers hand-deliver your documents directly to U.S. Department of State processing facilities. Vail's location on the I-70 corridor — 100 miles from Denver — makes our courier service the smart choice over dealing with mountain traffic, Eisenhower Tunnel backups, and unpredictable winter driving conditions.",
  fpcOfficeAddress: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
  fpcOfficeDistance: "Serving all of Eagle County and the Vail Valley from Vail Pass to Glenwood Canyon",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Vail and the Vail Valley. From the slopes of Vail Mountain and the village at Lionshead to the residential neighborhoods of East Vail and West Vail, from Beaver Creek to Bachelor Gulch — we serve every corner of the Vail Valley and all Eagle County communities.",
  nearbyCitiesIntro: "We serve Vail and all nearby communities including Avon, Beaver Creek, Edwards, Eagle, Minturn, Gypsum, Red Cliff, and Wolcott. We also serve Summit County communities — Frisco, Silverthorne, Dillon, and Breckenridge.",
  howItWorksIntro: "Most Vail travelers complete everything online and ship documents overnight. Our couriers handle all State Department delivery — no need to drive 100 miles to Denver through mountain traffic.",
  mistakesIntro: "Vail is one of the world's most visited ski resorts with travelers from across the globe. Here are the most common passport mistakes we see from Vail-area travelers.",
  testimonialsIntro: "Vail travelers — from winter ski enthusiasts to summer hikers to year-round Eagle County residents — trust us when departure is imminent.",
  faqIntro: "Have questions about expedited passports in Vail, CO? Here are the most common ones we hear from Vail Valley travelers.",
  statePageRoute: "/states/colorado",
  statePageName: "Colorado",
  dmvWebsite: "https://dmv.colorado.gov",
  dmvLabel: "Colorado DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Denver (2 hours each way)", "Eisenhower Tunnel and Vail Pass traffic"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No Denver drive — ship from Vail or Avon", "Ideal for ski trips and European alpine travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned seasonal travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Vail travelers with immediate departure needs — as fast as 24 hours. Our couriers get it done without the 2-hour drive to Denver.",
      bullets: ["24–48 hour turnaround available", "EGE international flight support", "European ski destination expertise"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Vail adults with a passport issued within the last 15 years. No post office appointment needed for most renewals.",
      bullets: ["No clerk visit required for most renewals", "Courier or mail-in options", "Returned to your Vail Valley address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Vail residents and Eagle County families — including seasonal workers and new citizens.",
      bullets: ["Acceptance facility scheduling in Vail or Avon", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Vail residents — whether you lost it on the mountain or it disappeared before a trip.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Vail and Eagle County families with kids heading to international ski destinations.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Vail and Eagle County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Vail CO", description: "Urgent passport processing for Vail Colorado travelers with immediate departure needs from EGE or DEN." },
    { name: "Expedited Passport Renewal Vail CO", description: "Fast passport renewal for Vail Colorado residents with a previously-issued passport." },
    { name: "First-Time Passport Vail CO", description: "New passport application services for Vail Colorado residents applying for their first passport." },
    { name: "Child Passport Vail CO", description: "Minor passport services for Vail Colorado families with children under 16." },
  ],
  testimonials: [
    {
      name: "Robert K.",
      location: "Vail, CO — Vail Village",
      rating: 5,
      text: "Ski trip to Zermatt booked and my passport had expired. Fast Passport Center had my renewal in 2 days. I shipped from the UPS Store in Avon and was on the slopes in Switzerland that weekend. Incredible service.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Jennifer M.",
      location: "Beaver Creek, CO",
      rating: 5,
      text: "Family trip to the Dolomites with 8 days notice. Two adult renewals and one child passport — all done in 5 days. The courier service saved us from making that awful I-70 drive to Denver.",
      service: "Family Passport Bundle",
    },
    {
      name: "David S.",
      location: "Edwards, CO",
      rating: 5,
      text: "Business trip to Tokyo with one week notice. Fast Passport Center processed my passport emergency in 3 days. With EGE just down the road, I connected through Denver and made my meeting.",
      service: "Emergency Passport",
    },
    {
      name: "Patricia L.",
      location: "Vail, CO — Lionshead",
      rating: 5,
      text: "Lost my passport at Vail Mountain during a ski day and had a trip to Canada in 10 days. They replaced it in 48 hours. No need to brave winter mountain driving to Denver.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "vai-1",
      name: "Vail Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1300 N Frontage Rd W",
      city: "Vail",
      state: "CO",
      zip: "81657",
      phone: "(970) 476-5217",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Vail, near the I-70 frontage road",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Vail acceptance facility. Appointments required — book ahead during ski season. Limited parking.",
      icon: "ri-mail-line",
    },
    {
      id: "vai-2",
      name: "Avon Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "111 W Beaver Creek Blvd",
      city: "Avon",
      state: "CO",
      zip: "81620",
      phone: "(970) 949-4431",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Avon, approximately 8 miles west of Vail Village",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Avon, Beaver Creek, and west Vail Valley residents. Extended hours and better parking than Vail.",
      icon: "ri-mail-line",
    },
    {
      id: "vai-3",
      name: "Edwards Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "105 Edwards Village Blvd",
      city: "Edwards",
      state: "CO",
      zip: "81632",
      phone: "(970) 926-3930",
      hours: "Mon–Fri: 8:30 AM – 4:00 PM",
      distance: "Edwards, approximately 14 miles west of Vail",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Edwards, Cordillera, and lower Vail Valley communities. Good alternative with easy access and parking.",
      icon: "ri-mail-line",
    },
    {
      id: "vai-4",
      name: "Eagle Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "264 Chambers Ave",
      city: "Eagle",
      state: "CO",
      zip: "81631",
      phone: "(970) 328-6332",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Eagle, approximately 28 miles west of Vail",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "County seat facility with extended hours. Convenient for Eagle, Gypsum, and western Eagle County residents. Near EGE airport.",
      icon: "ri-mail-line",
    },
    {
      id: "vai-5",
      name: "Eagle County Clerk — Eagle",
      type: "County Clerk Passport Acceptance",
      address: "500 Broadway",
      city: "Eagle",
      state: "CO",
      zip: "81631",
      phone: "(970) 328-8710",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Eagle, approximately 28 miles west of Vail",
      website: "https://www.eaglecounty.us/",
      websiteLabel: "Eagle County Clerk",
      notes: "County clerk passport acceptance with extended hours. Full-service facility for all Eagle County residents.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 100 mi to Denver, 2hr each way", fpc: "No — ship from Vail or Avon" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "I-70 Ski Traffic", agency: "Eisenhower Tunnel backups & closures", fpc: "No driving needed — courier handles it" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until Peak Ski Season",
      description: "Vail's busiest travel periods — Christmas, New Year's, Presidents' Week, and spring break — coincide with peak passport demand. Routine processing takes 8–11 weeks. Start expedited service at least 4 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo for International Travel",
      description: "Photos from local shops sometimes don't meet strict State Department standards. Must be exactly 2×2 inches on white background with no ski goggles tan lines visible.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities During Off-Season",
      description: "Vail acceptance facilities have limited hours during shoulder seasons (April–May and October–November). Book appointments well in advance.",
    },
    {
      icon: "ri-snowflake-line",
      title: "Underestimating I-70 Winter Travel",
      description: "Driving to the Denver passport agency means dealing with Vail Pass, the Eisenhower Tunnel, and Floyd Hill — all major winter bottlenecks. A 2-hour trip can easily become 5+ hours in bad weather.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking Passport Validity for European Travel",
      description: "Many European countries require 6 months of passport validity beyond your stay. Vail travelers heading to the Alps often discover this too late in the season.",
    },
    {
      icon: "ri-flight-takeoff-line",
      title: "Assuming EGE Always Has International Flights",
      description: "Eagle County Regional Airport offers seasonal international flights — primarily winter only. Summer international travel typically requires connecting through Denver.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in the Vail Valley." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop at any UPS or FedEx in Vail, Avon, or Edwards." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for mountain-town paperwork." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to State Department facilities — bypass the I-70 mountain corridor." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Vail Valley address — trackable every step." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Vail, CO?", a: "Fast Passport Center offers emergency passport processing in Vail, Colorado in as little as 24–48 hours. Our registered couriers hand-deliver your documents to U.S. Department of State facilities — no need to make the 100-mile drive over Vail Pass and through the Eisenhower Tunnel to Denver." },
    { q: "Does Vail have its own passport agency?", a: "No — Vail does not have a regional passport agency. The nearest is the Colorado Passport Agency (approximately 100 miles east via I-70 — a 2-hour drive in good conditions). Fast Passport Center's courier service means Vail residents never need to deal with mountain corridor traffic and road closures." },
    { q: "Can I fly internationally directly from Eagle County Regional Airport (EGE)?", a: "EGE offers seasonal international flights during winter (typically December–March) to select destinations. Year-round, EGE connects to major hubs like Denver (DEN), Dallas (DFW), Chicago (ORD), Atlanta (ATL), and others where you can connect to international flights. Always verify passport requirements for your full itinerary." },
    { q: "What if I live in Avon, Beaver Creek, Edwards, or Eagle?", a: "Absolutely. Fast Passport Center serves all of Eagle County including Avon, Beaver Creek, Edwards, Minturn, Eagle, Gypsum, Red Cliff, and Wolcott. We also serve neighboring Summit County communities. Our service works the same way everywhere." },
    { q: "Can you help with passports for Vail's seasonal employees and residents?", a: "Yes. Fast Passport Center serves both full-time Eagle County residents and seasonal workers/second-home owners. If you split your time between Vail and another location, we can coordinate to whichever address is most convenient." },
    { q: "How much does an expedited passport cost in Vail, CO?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline and destination." },
    { q: "Where can I get passport photos in Vail?", a: "City Market in Vail (2109 N Frontage Rd W) and the UPS Store in Avon (100 W Beaver Creek Blvd) offer passport photo services. Walgreens and FedEx Office in Avon also provide photos. Must be 2×2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center handle European ski destination travel?", a: "Yes. Fast Passport Center has extensive experience with Vail travelers heading to European ski destinations — Switzerland, France, Italy, Austria, and beyond. We understand the documentation requirements and tight timelines that come with international ski travel." },
  ],
  photoLocations: [
    { name: "City Market — Vail", address: "2109 N Frontage Rd W, Vail, CO 81657", hours: "Mon–Sun: 6AM–11PM" },
    { name: "UPS Store — Avon", address: "100 W Beaver Creek Blvd, Avon, CO 81620", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–3PM" },
    { name: "Walgreens — Avon", address: "50 Buck Creek Rd, Avon, CO 81620", hours: "Mon–Sun: 8AM–9PM" },
    { name: "FedEx Office — Avon", address: "160 Riverfront Ln, Avon, CO 81620", hours: "Mon–Fri: 7:30AM–7PM, Sat: 9AM–5PM" },
    { name: "Walmart — Avon", address: "171 Yoder Ave, Avon, CO 81620", hours: "Mon–Sun: 6AM–11PM" },
  ],
  dmvLocations: [
    { name: "DMV — Eagle (Eagle County)", address: "500 Broadway, Eagle, CO 81631", hours: "Mon–Fri: 8AM–5PM", note: "Full-service DMV for Eagle County residents. REAL ID and driver's license renewals. Approximately 28 miles west of Vail.", featured: true },
    { name: "DMV — Frisco (Summit County)", address: "37 Peak One Dr, Frisco, CO 80443", hours: "Mon–Fri: 8AM–5PM", note: "Alternative DMV for east Vail Valley residents near Summit County. REAL ID processing available. Approximately 30 miles east of Vail.", featured: false },
  ],
  airports: [
    {
      code: "EGE",
      name: "Eagle County Regional Airport",
      distance: "35 miles west of Vail in Gypsum",
      address: "219 Eldon Wilson Rd, Gypsum, CO 81637",
      note: "Primary airport for Vail and the Vail Valley. Seasonal international flights (winter) and year-round domestic connections to major hubs including DEN, DFW, ORD, ATL, LAX, IAH, JFK, MIA, and PHX. The closest airport to Vail with commercial service.",
      flightUrl: "https://www.eaglecounty.us/airport",
      flightLabel: "EGE Flight Info",
      featured: true,
    },
    {
      code: "ASE",
      name: "Aspen-Pitkin County Airport",
      distance: "70 miles southwest of Vail via Highway 82",
      address: "233 E Airport Rd, Aspen, CO 81611",
      note: "Regional alternative for Roaring Fork Valley connections. Domestic-only with connections to major hubs.",
      flightUrl: "https://www.aspenairport.com/",
      flightLabel: "ASE Flight Info",
      featured: false,
    },
    {
      code: "DEN",
      name: "Denver International Airport",
      distance: "120 miles east of Vail via I-70",
      address: "8500 Peña Blvd, Denver, CO 80249",
      note: "Colorado's primary international airport. Nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. 2–2.5 hour drive from Vail in good conditions.",
      flightUrl: "https://www.flydenver.com/",
      flightLabel: "DEN Flight Info",
      featured: false,
    },
  ],
};